import { get } from "lodash";
import React, { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GeneralMessage, GeneralRadio } from "../../../../../components";
import { MedicalKeys } from "../../../../../enums/MedicalReportEnums";
import { IStepFields } from "../../../../../interface/MedicalRecord";
import { PregnancyCalculate } from "../../../../../utils/PregnancyCalculate";
import { FieldRenderer } from "../../FieldRenderer/FieldRenderer";
interface Option extends IStepFields {
  key: string | number;
  value: string | number;
  label: string;
}

interface GeneralRadioWithInputProps {
  label: string;
  options: Option[];
  name: string;
  fieldConfig: any;
  disabled?: boolean;
  isRequired?: boolean;
}

const GeneralRadioWithInput: React.FC<GeneralRadioWithInputProps> = ({
  name,
  label,
  options = [],
  fieldConfig,
  disabled,
  isRequired,
}) => {


  const { t } = useTranslation();
  const methods = useFormContext();
  const prevValueRef = useRef<string | number | undefined>(undefined);
  const currentValue = methods.watch(name);
  const errorMessage = get(methods.formState?.errors, name)?.message;
  const selectedOption = options?.find(
    (item) => `${methods.watch(name)}` == `${item?.value}`,
  );
  const optionHasChildren =
    selectedOption?.InverseParentStepFields &&
    selectedOption?.InverseParentStepFields?.length > 0;

  const isGender = MedicalKeys.Gender === name;
  const pregnancyDate = methods.watch(fieldConfig)?.DateOfPregnancy;
  const { weeks, estimatedDueDate } = PregnancyCalculate(pregnancyDate)


  const resetValues = () => options.forEach(element => {
    element?.InverseParentStepFields?.forEach((child) => {

      methods.setValue(
        `${child.Key ?? `Attributes.${String(child?.Id)}`}`,
        "",
        // { shouldDirty: true, shouldValidate: true },
      );
    });
  });



  return (
    <div className="bg-primary-bg w-full rounded-lg px-4 py-4">
      <div className="mx-auto flex justify-between">
        <h2>{t(label)}</h2>
        <div className={`flex gap-3 ${options?.length > 3 ? "flex-wrap" : ""}`}>
          {options?.map((item, index) => {
            return (
              <GeneralRadio
                {...item}
                className="!text-primary-text"
                disabled={disabled}
                key={index}
                name={name}
                label={t(item?.label)}
                checked={
                  `${methods.watch(name)}`?.toLowerCase() ==
                  `${item?.value}`?.toLowerCase()
                }
                onClick={() => {
                  resetValues()
                  methods.setValue(name, `${item?.value}`);

                }}
              />
            );
          })}
        </div>
      </div>
      {(errorMessage) && (
        <span className="error text-xs text-error">
          {errorMessage as string ?? t("required")}
        </span>
      )}

      {optionHasChildren && (
        <div className={`mt-2 flex flex-wrap gap-2 ${selectedOption?.InverseParentStepFields?.length > 3 ? "" : "lg:flex-nowrap"}`}>
          {selectedOption?.InverseParentStepFields?.map((item, i) => (
            <FieldRenderer field={item} key={i} />
          ))}
        </div>
      )}
      {isGender && pregnancyDate && (
        <GeneralMessage
          status="warning"
          className="flex !max-h-40 max-w-full justify-start"
          message={t("patient_pregnant_at_week", { week: weeks }) + ", " + t("edd") + " " + estimatedDueDate}
        />
      )}

    </div>
  );
};

export default GeneralRadioWithInput;
